import React, { FC } from 'react';

import * as ST from './styled';

interface IWidget extends FC {
    ImageBlock: typeof ST.ImageBlock,
    Image: typeof ST.Image,
    HeaderBlock: typeof ST.HeaderBlock,
    ContentBlock: typeof ST.ContentBlock,
    PeriodData: typeof ST.PeriodData,
    Name: typeof ST.Name,
    Description: typeof ST.Description,
    Info: typeof ST.Info,
    FooterBlock: typeof ST.FooterBlock,
    Price: typeof ST.Price,
    PriceInfo: typeof ST.PriceInfo,
    PriceWrap: typeof ST.PriceWrap,
    Kebab: typeof ST.Kebab,
    InfoPaymentWrap: typeof ST.InfoPaymentWrap,
    ButtonGroup: typeof ST.ButtonGroup,
}

const Widget: IWidget = ({ children }) => {
    return (
        <ST.Wrapper>
            {children}
        </ST.Wrapper>
    );
};

Widget.ImageBlock = ST.ImageBlock;
Widget.Image = ST.Image;
Widget.HeaderBlock = ST.HeaderBlock;
Widget.ContentBlock = ST.ContentBlock;
Widget.PeriodData = ST.PeriodData;
Widget.Name = ST.Name;
Widget.Description = ST.Description;
Widget.Info = ST.Info;
Widget.FooterBlock = ST.FooterBlock;
Widget.Price = ST.Price;
Widget.PriceInfo = ST.PriceInfo;
Widget.PriceWrap = ST.PriceWrap;
Widget.Kebab = ST.Kebab;
Widget.InfoPaymentWrap = ST.InfoPaymentWrap;
Widget.ButtonGroup = ST.ButtonGroup;

export default Widget;
